import { Store } from 'react-notifications-component';
import {
  get,
  post,
  put,
  remove,
} from '@api';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
} from '@constants/notification-settings';

export const FETCH_MENUS_START = 'FETCH_MENUS_START';
export const FETCH_MENUS_SUCCESS = 'FETCH_MENUS_SUCCESS';
export const FETCH_MENUS_FAIL = 'FETCH_MENUS_FAIL';
export const CREATE_MENU_START = 'CREATE_MENU_START';
export const CREATE_MENU_SUCCESS = 'CREATE_MENU_SUCCESS';
export const CREATE_MENU_FAIL = 'CREATE_MENU_FAIL';
export const DELETE_MENU_START = 'DELETE_MENU_START';
export const DELETE_MENU_SUCCESS = 'DELETE_MENU_SUCCESS';
export const DELETE_MENU_FAIL = 'DELETE_MENU_FAIL';
export const FETCH_MENU_ITEM_START = 'FETCH_MENU_ITEM_START';
export const FETCH_MENU_ITEM_SUCCESS = 'FETCH_MENU_ITEM_SUCCESS';
export const FETCH_MENU_ITEM_FAIL = 'FETCH_MENU_ITEM_FAIL';
export const UPDATE_MENU_TITLE_START = 'UPDATE_MENU_TITLE_START';
export const UPDATE_MENU_TITLE_SUCCESS = 'UPDATE_MENU_TITLE_SUCCESS';
export const UPDATE_MENU_TITLE_FAIL = 'UPDATE_MENU_TITLE_FAIL';
export const UPDATE_MENU_SELECTION_START = 'UPDATE_MENU_SELECTION_START';
export const UPDATE_MENU_SELECTION_SUCCESS = 'UPDATE_MENU_SELECTION_SUCCESS';
export const UPDATE_MENU_SELECTION_FAIL = 'UPDATE_MENU_SELECTION_FAIL';

export const UPDATE_MENUS_POSITIONS = 'UPDATE_MENUS_POSITIONS';
export const SET_INCLUDED_MENU_ITEMS = 'SET_INCLUDED_MENU_ITEMS';
export const SET_INCLUDED_MENU_ITEMS_BY_MENU_ID = 'SET_INCLUDED_MENU_ITEMS_BY_MENU_ID';

export const updateMenusPositions = (payload) => ({
  type: UPDATE_MENUS_POSITIONS,
  payload
});

export const setIncludedMenuItems = (payload) => ({
  type: SET_INCLUDED_MENU_ITEMS,
  payload: Array.isArray(payload) ? payload : []
});

export const setIncludedMenuItemsByMenuId = (payload) => ({
  type: SET_INCLUDED_MENU_ITEMS_BY_MENU_ID,
  payload
});

const fetchMenusStart = () => ({
  type: FETCH_MENUS_START,
});

export const fetchMenusSuccess = (payload) => ({
  type: FETCH_MENUS_SUCCESS,
  payload,
});

const fetchMenusFail = (error) => ({
  type: FETCH_MENUS_FAIL,
  payload: error,
});

const createMenuStart = () => ({
  type: CREATE_MENU_START,
});

export const createMenuSuccess = (payload) => ({
  type: CREATE_MENU_SUCCESS,
  payload,
});

const createMenuFail = (error) => ({
  type: CREATE_MENU_FAIL,
  payload: error,
});

const deleteMenuStart = () => ({
  type: DELETE_MENU_START,
});

export const deleteMenuSuccess = (payload) => ({
  type: DELETE_MENU_SUCCESS,
  payload,
});

const deleteMenuFail = (error) => ({
  type: DELETE_MENU_FAIL,
  payload: error,
});

const fetchMenuItemStart = () => ({
  type: FETCH_MENU_ITEM_START,
});

const fetchMenuItemSuccess = (payload) => ({
  type: FETCH_MENU_ITEM_SUCCESS,
  payload,
});

const fetchMenuItemFail = (error) => ({
  type: FETCH_MENU_ITEM_FAIL,
  payload: error,
});

const updateMenuTitleStart = () => ({
  type: UPDATE_MENU_TITLE_START,
});

const updateMenuTitleSuccess = (payload) => ({
  type: UPDATE_MENU_TITLE_SUCCESS,
  payload,
});

const updateMenuTitleFail = (error) => ({
  type: UPDATE_MENU_TITLE_FAIL,
  payload: error,
});

const updateMenuSelectionStart = () => ({
  type: UPDATE_MENU_SELECTION_START,
});

const updateMenuSelectionSuccess = (payload) => ({
  type: UPDATE_MENU_SELECTION_SUCCESS,
  payload,
});

const updateMenuSelectionFail = (error) => ({
  type: UPDATE_MENU_SELECTION_FAIL,
  payload: error,
});

export const fetchMenus = () => async (dispatch) => {
  dispatch(fetchMenusStart());
  try {
    const response = await get('/menus');
    dispatch(fetchMenusSuccess({
      data: response.data,
    }));
  } catch (e) {
    dispatch(fetchMenusFail(e));
  }
};

export const createMenu = (body, translations, setNewItemProcess) => async (dispatch) => {
  dispatch(createMenuStart());
  try {
    const response = await post('/menus', body);
    dispatch(createMenuSuccess({
      data: response.data,
    }));
    setNewItemProcess((prev) => prev.filter((elId) => elId !== body.identifier));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(createMenuFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const deleteMenu = (id, translations, setDeleteProcess) => async (dispatch) => {
  dispatch(deleteMenuStart());
  try {
    await remove(`/menus/${id}`);
    dispatch(deleteMenuSuccess(id));
    setDeleteProcess((prev) => prev.filter((elId) => elId !== id));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(deleteMenuFail(e));
    setDeleteProcess((prev) => prev.filter((elId) => elId !== id));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
    return false;
  }
};

export const fetchMenuItem = (id) => async (dispatch) => {
  dispatch(fetchMenuItemStart());
  try {
    const response = await get(`/menus/${id}`);
    dispatch(fetchMenuItemSuccess({
      data: response.data,
    }));
  } catch (e) {
    dispatch(fetchMenuItemFail(e));
  }
};

export const fetchMenuIncludedItems = (id, returnValue = false) => async (dispatch) => {
  try {
    const response = await get(`/menus/${id}/included`);
    if (returnValue) {
      return response.data;
    } else {
      dispatch(setIncludedMenuItems(response.data));
    }
  } catch (e) {
    dispatch(fetchMenuItemFail(e));
  }
};

export const updateMenuTitle = (id, body, translations) => async (dispatch) => {
  dispatch(updateMenuTitleStart());
  try {
    await put(`/menus/${id}`, body);
    dispatch(updateMenuTitleSuccess({
      id,
      localizeInfos: body.localizeInfos,
      pagesIds: body.pagesIds,
    }));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(updateMenuTitleFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const updateMenuSelection = (id, body, translations) => async (dispatch) => {
  dispatch(updateMenuSelectionStart());
  try {
    await put(`/menus/${id}`, body);
    dispatch(updateMenuSelectionSuccess({
      id,
      localizeInfos: body.localizeInfos,
      pagesIds: body.pagesIds,
    }));
    dispatch(fetchMenuIncludedItems(id));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(updateMenuSelectionFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

/**
 * Action types для CRUD-операций над кастомными пунктами меню.
 * Используются reducer'ом для синхронного обновления state.menu.customItems
 * без полного refetch меню — UI должен отражать изменение моментально.
 */
export const ADD_MENU_CUSTOM_ITEM_SUCCESS = 'ADD_MENU_CUSTOM_ITEM_SUCCESS';
export const UPDATE_MENU_CUSTOM_ITEM_SUCCESS = 'UPDATE_MENU_CUSTOM_ITEM_SUCCESS';
export const DELETE_MENU_CUSTOM_ITEM_SUCCESS = 'DELETE_MENU_CUSTOM_ITEM_SUCCESS';
export const UPDATE_POSITION_MENU_CUSTOM_ITEM_SUCCESS = 'UPDATE_POSITION_MENU_CUSTOM_ITEM_SUCCESS';

const addMenuCustomItemSuccess = (payload) => ({
  type: ADD_MENU_CUSTOM_ITEM_SUCCESS,
  payload,
});

const updateMenuCustomItemSuccess = (payload) => ({
  type: UPDATE_MENU_CUSTOM_ITEM_SUCCESS,
  payload,
});

const deleteMenuCustomItemSuccess = (payload) => ({
  type: DELETE_MENU_CUSTOM_ITEM_SUCCESS,
  payload,
});

const updatePositionMenuCustomItemSuccess = (payload) => ({
  type: UPDATE_POSITION_MENU_CUSTOM_ITEM_SUCCESS,
  payload,
});

/**
 * Создаёт кастомный пункт меню.
 * Бэк отвечает созданной сущностью — её мы кладём в state.menu.customItems
 * через ADD_MENU_CUSTOM_ITEM_SUCCESS, чтобы UI обновился без полного refetch.
 * Тосты success/fail — общие для всех мутаций меню.
 */
export const addMenuCustomItem = (menuId, body, translations) => async (dispatch) => {
  try {
    const response = await post(`/menus/${menuId}/custom-items`, body);
    dispatch(addMenuCustomItemSuccess({
      menuId,
      item: response.data,
    }));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return response.data;
  } catch (e) {
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    throw e;
  }
};

/**
 * Обновляет существующий кастомный пункт меню (title / value).
 * Replace по itemId в state.menu.customItems.
 */
export const updateMenuCustomItem = (menuId, itemId, body, translations) => async (dispatch) => {
  try {
    const response = await put(`/menus/${menuId}/custom-items/${itemId}`, body);
    dispatch(updateMenuCustomItemSuccess({
      menuId,
      itemId,
      item: response.data,
    }));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return response.data;
  } catch (e) {
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    throw e;
  }
};

/**
 * Удаляет кастомный пункт меню. Filter по itemId в state.menu.customItems.
 * Тосты — COMMON_DATA_DELETE_*, отдельно от update-операций.
 *
 * `flag` управляет каскадом на бэке (значения из DeletePageFlags — общая
 * конвенция с удалением страниц): SELF_ONLY удаляет только сам пункт,
 * SELF_WITH_CHILDREN — пункт вместе с вложенными кастомными пунктами.
 * Вложенные страницы каскад не трогает (они не принадлежат пункту) — их
 * отвязывает caller через updateMenuSelection.
 */
export const deleteMenuCustomItem = (menuId, itemId, translations, flag = 'self_only') => async (dispatch) => {
  try {
    await remove(`/menus/${menuId}/custom-items/${itemId}`, { data: { flag } });
    dispatch(deleteMenuCustomItemSuccess({
      menuId,
      itemId,
    }));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
    return true;
  } catch (e) {
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
    throw e;
  }
};

/**
 * Обновляет position кастомного пункта меню (drag-and-drop).
 * Тосты не показываем — операция типично пакетная при сортировке.
 * Body — { position: number, newParentId: null } согласно бэкенду.
 */
export const updateMenuCustomItemPosition = (menuId, itemId, body) => async (dispatch) => {
  try {
    const response = await put(`/menus/${menuId}/custom-items/${itemId}/position`, body);
    dispatch(updatePositionMenuCustomItemSuccess({
      menuId,
      itemId,
      item: response.data,
    }));
    return response.data;
  } catch (e) {
    // Поверхностный лог — ошибка позиции не блокирует UI, выбрасываем выше для retry/обработки в caller'е.
    console.error('updateMenuCustomItemPosition error:', e);
    throw e;
  }
};
